























































































































































































































































































































































import { AddOnServiceViewForFinancialDocuments } from "@/shared/models/addOnService";
import { ListModel } from "@/shared/models/listModel";
import { Component, PropSync, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { FinDocLineItemViewModel, FinDocViewModel } from "./models";
import * as _ from "lodash";
import { TaxRateView } from "@/shared/models/taxRates";
import NumericInputImproved from "@/components/numbers/NumericInputImproved.vue";
import CurrencyDisplay from "@/components/misc/CurrencyDisplay.vue";
import {
  fillInvoiceEditingTaxExemptionReason,
  clearTaxExemption,
  calculateLineItem,
  calculateLineItemDiscount,
} from "./functions";
import { FinancialSettingsType } from "@/store/modules/financial";
import {
  FinancialDocumentStatusEnum,
  FinancialDocumentTypesEnum,
} from "@/shared/models/enums.type";
import { MultipleReservationsInvoicingViewModel } from "../MultipleReservationsInvoice/types";
import {
  MultipleDocumentsInvoicingViewModel,
  MultipleDocumentsLineItem,
} from "../MultipleDocumentsInvoice/types";
import MultipleReservationsInvoice from "@/components/finances/MultipleReservationsInvoice/MultipleReservationsInvoice.vue";
import MultipleDocumentsInvoice from "@/components/finances/MultipleDocumentsInvoice/MultipleDocumentsInvoice.vue";
import { CustomerModel } from "@/shared/models/vCustomer";
import { round } from "lodash";
import { UnitOfMeasureView } from "@/shared/models/unitOfMeasure";

@Component({
  components: {
    NumericInputImproved,
    CurrencyDisplay,
    MultipleReservationsInvoice,
    MultipleDocumentsInvoice,
  },
})
export default class LineItems extends Vue {
  @PropSync("finDocModel") finDocModelInternal!: FinDocViewModel;

  isSearchingServices = false;
  addOnServices = [] as AddOnServiceViewForFinancialDocuments[];

  propertyIdForMultipleReservationsInvoicing: number | null = null;
  multipleReservationsInvoicingOpen = false;
  multipleDocumentsInvoicingOpen = false;

  get showActionButtons() {
    return !this.finDocModelInternal.reservationId;
  }

  get isLocked() {
    return (
      this.finDocModelInternal.documentStatusId !==
      FinancialDocumentStatusEnum.UIzradi
    );
  }

  get isCancellation() {
    return (
      this.finDocModelInternal.documentTypeId ===
      FinancialDocumentTypesEnum.Storno
    );
  }

  get isInvoice() {
    return (
      this.finDocModelInternal.documentTypeId ===
      FinancialDocumentTypesEnum.Racun
    );
  }

  get lineItems() {
    return this.finDocModelInternal.lineItems;
  }

  get isAnyItemFoodOrBeverage() {
    return this.lineItems.some((x) => x.isFoodAndBeverages);
  }

  get workingCurrency() {
    return {
      id: this.finDocModelInternal.workingCurrencyId,
      code: this.finDocModelInternal.workingCurrencyISO3,
    };
    }

    get formalCurrency() {
        if (!this.finDocModelInternal.formalCurrencyId) return null;

        return {
            id: this.finDocModelInternal.formalCurrencyId,
            code: this.finDocModelInternal.formalCurrencyISO3,
        };
    }

  get hasTaxExemption() {
    const taxExempt = this.lineItems.some(
      (x) => (this.taxRates?.find((e) => e.id === x.taxRateId)?.rate ?? 0) === 0
    );

    return taxExempt;
  }

  get servicePeriod() {
    if (
      this.finDocModelInternal.basicInfo.servicePeriodFromDate &&
      this.finDocModelInternal.basicInfo.servicePeriodToDate
    ) {
      return [
        this.finDocModelInternal.basicInfo.servicePeriodFromDate,
        this.finDocModelInternal.basicInfo.servicePeriodToDate,
      ];
    }

    return undefined;
  }

  // functions
  calculateLineItem = calculateLineItem;
  calculateLineItemDiscount(
    lineItem: FinDocLineItemViewModel,
    taxRates: TaxRateView[]
  ) {
    calculateLineItemDiscount(
      lineItem,
      taxRates,
      this.workingToFormalConversionRate
    );
  }

  itemTaxRateChanged() {
    const userInput = clearTaxExemption(
      this.lineItems,
      this.finDocModelInternal.taxExemptionReason
    );
    this.resetTaxExemption(userInput);
  }

  addItem() {
    let taxRate = this.taxRates[0];
    if (this.storedSettings) { 
      taxRate = this.tenantPaysVat ? 
      this.storedSettings.standardTaxRate : this.storedSettings.outOfScopeTaxRate 
    }

    const counter =
      this.lineItems.length > 0
        ? Math.max(...this.lineItems.map((e) => e.itemNumber))
        : 0;
    const newLineItem = {
      ...new FinDocLineItemViewModel(),
      itemNumber: counter + 1,
      taxRateId: taxRate.id
    };

    calculateLineItem(
      newLineItem,
      this.taxRates,
      this.workingToFormalConversionRate
    );

    this.lineItems.push(newLineItem);
  }

  // TODO: figure out after we need complex multicurrency again
  // addExchangeDifferenceLineItem() {
  //   const counter = Math.max(...this.lineItems.map((e) => e.itemNumber));

  //   this.lineItems.push({
  //     ...new FinDocLineItemViewModel(),
  //     itemName: this.$t("ExchangeRateDifferenceLineItemName").toString(),
  //     itemNumber: counter + 1,
  //     unitOfMeasureId: UnitsOfMesureEnum.Kom,
  //     taxRateId: TaxRatesEnum.VatOutOfScope,
  //   });

  //   const userInput = clearTaxExemption(
  //     this.lineItems,
  //     this.finDocModelInternal.taxExemptionReason
  //   );
  //   this.resetTaxExemption(userInput);
  // }

  get isMultiDocInvoice() {
    return this.lineItems.some((e) => e.sourceFinancialDocumentId);
  }

  deleteItem(item: FinDocLineItemViewModel) {
    if (this.isMultiDocInvoice && item.sourceFinancialDocumentId) {
      this.$store.dispatch("showNotification", {
        color: "warning",
        message: this.$t("DeleteMultiDocItemsConfirmation"),
        actions: [
          {
            text: this.$t("Continue"),
            fun: () => {
              this.removeAllDocumentItems(item);
              return true;
            },
          },
          {
            text: this.$t("Cancel"),
            fun: () => {
              return true;
            },
          },
        ],
        timeout: 30000,
      });

      return;
    }
    else {
      const itemName = item?.itemName.length > 50
      ? item?.itemName.substring(0, 50) + '...'
      : item?.itemName
      this.$store.dispatch("showNotification", {
      id: item.id,
      color: "warning",
      message: this.$t("FinancialDocument.LineItemDeleteConfirmation") + ` '${itemName}'?`,
      actions: [
        {
          text: this.$t("Delete"),
          fun: () => {
            this.removeItem(item);
            return true;
          },
        },
        {
          text: this.$t("Cancel"),
          fun: () => {
            return true;
          },
        },
      ],
      timeout: 30000,
    });
    }

    
  }

  removeItem(item: FinDocLineItemViewModel) {
    const userInput = clearTaxExemption(
      this.lineItems,
      this.finDocModelInternal.taxExemptionReason
    );
    const idx = this.lineItems.indexOf(item);
    if (idx >= 0) {
      this.lineItems.splice(idx, 1);
    }
    this.resetTaxExemption(userInput);
  }

  removeAllDocumentItems(item: FinDocLineItemViewModel) {
    const userInput = clearTaxExemption(
      this.lineItems,
      this.finDocModelInternal.taxExemptionReason
    );

    this.finDocModelInternal.lineItems =
      this.finDocModelInternal.lineItems.filter(
        (e) => e.sourceFinancialDocumentId !== item.sourceFinancialDocumentId
      );
    this.resetTaxExemption(userInput);
  }

  resetTaxExemption(userInput: string) {
    fillInvoiceEditingTaxExemptionReason(
      this.finDocModelInternal,
      false,
      this.tenantPaysVat
    );
    if (userInput !== "" && userInput != undefined) {
      if (this.finDocModelInternal.taxExemptionReason != "")
        this.finDocModelInternal.taxExemptionReason += "\n" + userInput;
      else this.finDocModelInternal.taxExemptionReason += userInput;
    }
  }

  onAddOnServicesSearchInputChanged(fresh: string) {
    this.debouncedSearchAddOnServices(fresh);
  }

  showNoAddOnServiceItems = false;
  debouncedSearchAddOnServices = _.debounce(this.searchAddOnServices, 500);
  searchAddOnServices(search: string) {
    this.showNoAddOnServiceItems = false;

    if (!search && !this.disableCustomAddOnServiceLineItems) {
      this.addOnServices = [];
      this.$nextTick(() => {
        this.showNoAddOnServiceItems = true;
      });
      return;
    }

    this.isSearchingServices = true;
    this.axios
      .get<ListModel<AddOnServiceViewForFinancialDocuments>>(
        "addOnServices/getForDocuments",
        {
          params: {
            name: search,
            culture: this.internalLanguage.split("-")[0] ?? null,
          },
        }
      )
      .then((res) => {
        this.addOnServices = [];
        this.$nextTick(() => {
          this.addOnServices = res.data.result;
          this.showNoAddOnServiceItems = true;
        });
      })
      .finally(() => {
        this.isSearchingServices = false;
      });
  }

  disableLineItemChange = false;
  onItemNameKeyDown(event: KeyboardEvent, item: FinDocLineItemViewModel) {
    item.itemName = (event.target as HTMLInputElement).value;
    if (event.code == "Tab") {
      //remove itemName here because it messes with double events later (when pressing tab)
      if (this.disableCustomAddOnServiceLineItems) {
        item.itemName = "";
      }
      this.disableLineItemChange = true;
    }
  }

  onSelectedServiceChanged(
    value: string | AddOnServiceViewForFinancialDocuments,
    item: FinDocLineItemViewModel
  ) {
    if (typeof value === "string") {
      //when user presses 'Tab' key, 'onSelectedServiceChanged event will be triggered twice
      //first time with correct AOS to autocomplete, second time with string that was used to search AOS
      //so with this we are disabling that second event (flag was set to true when user pressed TAB)
      if (this.disableLineItemChange) {
        this.disableLineItemChange = false;
        return;
      } else if (this.disableCustomAddOnServiceLineItems) {
        item.itemName = "";
        return;
      }

      item.itemName = value;
      return;
    }

    if (value) {
      item.itemName = value.name;
      item.addOnServiceId = value.id;

      item.isCityTax = value.isCityTax;
      item.isFoodAndBeverages = value.isFoodAndBeverages;

      item.taxRateId = value.taxRateId;
      item.taxExemptionReasonFromAOS = value.taxExemptionReason;
      item.consumptionTaxRate = value.consumptionTaxRate;
      if (value.unitOfMeasureId) item.unitOfMeasureId = value.unitOfMeasureId;
      item.grossUnitPrice = value.grossPrice;

      calculateLineItem(
        item,
        this.taxRates,
        this.workingToFormalConversionRate
      );
    }

    const userInput = clearTaxExemption(
      this.lineItems,
      this.finDocModelInternal.taxExemptionReason
    );
    this.resetTaxExemption(userInput);
  }

  mergeExistingReservations(
    model: MultipleReservationsInvoicingViewModel,
    servicePeriodFromDate: string,
    servicePeriodToDate: string
  ) {
    this.propertyIdForMultipleReservationsInvoicing = model.propertyId;

    // set service period
    const incomingFrom = servicePeriodFromDate
      ? servicePeriodFromDate
      : new Date(model.servicePeriodFrom).toISOString().substr(0, 10);
    const incomingTo = servicePeriodToDate
      ? servicePeriodToDate
      : new Date(model.servicePeriodTo).toISOString().substr(0, 10);

    if (
      !this.finDocModelInternal.basicInfo.servicePeriodFromDate ||
      this.finDocModelInternal.basicInfo.servicePeriodFromDate > incomingFrom
    )
      this.finDocModelInternal.basicInfo.servicePeriodFromDate = incomingFrom;

    if (
      !this.finDocModelInternal.basicInfo.servicePeriodToDate ||
      this.finDocModelInternal.basicInfo.servicePeriodToDate < incomingTo
    )
      this.finDocModelInternal.basicInfo.servicePeriodToDate = incomingTo;

    // set client
    if (!this.finDocModelInternal.clientInfo.id && model.customerId) {
      this.finDocModelInternal.clientInfo.id = model.customerId;
      this.refreshClientInfo();
    }

    // set business unit
    if (model.defaultBusinessUnitId) {
      this.finDocModelInternal.basicInfo.businessUnitId =
        model.defaultBusinessUnitId;
      this.finDocModelInternal.basicInfo.cashRegisterId = null;
    }

    const newRelatedAdvanceInvoices = model.unassignedAdvanceInvoices.filter(
      (e) =>
        !this.finDocModelInternal.relatedAdvanceInvoices.some(
          (r) => r.id === e.id
        ) &&
        !this.finDocModelInternal.unassignedAdvanceInvoices.some(
          (u) => u.id === e.id
        )
    );

    this.finDocModelInternal.relatedAdvanceInvoices.push(
      ...newRelatedAdvanceInvoices
    );

    // skip adding line items for units which are already on the invoice
    const newLineItems = model.lineItems.filter(
      (x) =>
        !this.finDocModelInternal.lineItems.some(
          (e) => x.reservationAccUnitTypeId === e.reservationAccUnitTypeId
        )
    );

    newLineItems.forEach((e) => {
      calculateLineItem(e, this.taxRates, this.workingToFormalConversionRate);
      this.finDocModelInternal.lineItems.push({
        ...e,
      });
    });

    // clear empty line items and reset item numbers
    this.finDocModelInternal.lineItems =
      this.finDocModelInternal.lineItems.filter(
        (e) => _.trim(e.itemName).length !== 0 || e.grossUnitPrice !== 0
      );
    this.finDocModelInternal.lineItems.forEach(
      (e, index) => (e.itemNumber = index)
    );

    const userInput = clearTaxExemption(
      this.finDocModelInternal.lineItems,
      this.finDocModelInternal.taxExemptionReason
    );
    this.resetTaxExemption(userInput);
    this.multipleReservationsInvoicingOpen = false;

    if (model.warnings && model.warnings.length > 0) {
      model.warnings.forEach((e) => {
        this.$store.dispatch("showNotification", {
          color: "warning",
          message: e,
          timeout: 10000,
          localize: true,
        });
      });
    }
  }

  // multidocument invoice
  mergeExistingInvoices(data: MultipleDocumentsInvoicingViewModel[]) {
    // if there's no client set on the document then set it
    if (this.finDocModelInternal.clientInfo.id === 0) {
      const allSameClient = !data.some(
        (x) => x.customerId != data[0]?.customerId
      );

      if (allSameClient) {
        this.finDocModelInternal.clientInfo.id = data[0]?.customerId ?? 0;
      } else {
        this.finDocModelInternal.clientInfo.id = 0;
      }
    }
    // if there already is a client, and any of the new documents has a different client, then reset the client to empty
    else {
      const someDifferent = data.some(
        (x) => x.customerId != this.finDocModelInternal.clientInfo.id
      );

      if (someDifferent) {
        this.finDocModelInternal.clientInfo.id = 0;
      }
    }

    this.refreshClientInfo();

    // figure out and set the service period
    const lineItems = data.flatMap((e) => e.lineItems);
    const minDate = Math.min(
      ...lineItems.map((o) =>
        new Date(o.servicePeriodFromDate?.substr(0, 10) ?? "").getTime()
      )
    );
    const maxDate = Math.max(
      ...lineItems.map((o) =>
        new Date(o.servicePeriodToDate?.substr(0, 10) ?? "").getTime()
      )
    );
    const currentServicePeriodFrom = this.finDocModelInternal.basicInfo
      .servicePeriodFromDate
      ? new Date(
          this.finDocModelInternal.basicInfo.servicePeriodFromDate.substr(0, 10)
        ).getTime()
      : null;
    const currentServicePeriodTo = this.finDocModelInternal.basicInfo
      .servicePeriodToDate
      ? new Date(
          this.finDocModelInternal.basicInfo.servicePeriodToDate.substr(0, 10)
        ).getTime()
      : null;

    try {
      if (!currentServicePeriodFrom || currentServicePeriodFrom > minDate) {
        this.finDocModelInternal.basicInfo.servicePeriodFromDate = new Date(
          minDate
        )
          .toISOString()
          .substr(0, 10);
      }
    } catch {
      this.finDocModelInternal.basicInfo.servicePeriodFromDate = null;
    }

    try {
      if (!currentServicePeriodTo || currentServicePeriodTo < maxDate) {
        this.finDocModelInternal.basicInfo.servicePeriodToDate = new Date(
          maxDate
        )
          .toISOString()
          .substr(0, 10);
      }
    } catch {
      this.finDocModelInternal.basicInfo.servicePeriodToDate = null;
    }

    // remove empty line items, and reset itemNumber values
    this.finDocModelInternal.lineItems =
      this.finDocModelInternal.lineItems.filter(
        (e) => _.trim(e.itemName).length !== 0 || e.grossUnitPrice !== 0
      );
    this.finDocModelInternal.lineItems.forEach(
      (e, index) => (e.itemNumber = index)
    );
    let counter = Math.max(
      ...this.finDocModelInternal.lineItems.map((x) => x.itemNumber),
      0
    );

    const originalTotalPrice = this.finDocModelInternal.lineItems.reduce(
      (sum, e) => sum + e.grossPrice,
      0
    );

    // add new line items
    for (const item of lineItems) {
      const doc = data.find(
        (e) => e.financialDocumentId === item.financialDocumentId
      );
      if (doc) {
        const newItem: FinDocLineItemViewModel = {
          ...new FinDocLineItemViewModel(),
          itemName: this.getMultiDocumentLineItemName(item, doc),
          itemNumber: ++counter,
          financialDocumentId: this.finDocModelInternal.id,
          sourceFinancialDocumentId: item.financialDocumentId,
          sourceLineItemId: item.id,
          reservationAccUnitTypeId: item.reservationAccUnitTypeId,
          resAccUnitTypeAddOnServiceId: item.resAccUnitTypeAddOnServiceId,
          addOnServiceId: item.addOnServiceId,
          isCityTax: item.isCityTax,
          isFoodAndBeverages: item.isFoodAndBeverages,

          unitOfMeasureId: item.unitOfMeasureId,
          decimalQuantity: item.decimalQuantity,
          taxRateId: item.taxRateId,
          consumptionTaxRate: item.consumptionTaxRate,
          grossUnitPrice: item.grossUnitPrice,
          discountPercent: item.discountPercent,

          ownerId: item.ownerId,
          agencyWorkModelId: item.agencyWorkModelId,
          ownerIsLegalEntity: item.ownerIsLegalEntity,
          taxExemptionReasonFromAOS: item.taxExemptionReasonFromAOS,
          isGroupedStayLineItem: item.isGroupedStayLineItem,

          isStayCancellation: item.isStayCancellation,
          ownerIsResident: item.ownerIsResident,
          ownerPaysVAT: item.ownerPaysVAT,
          ownerVatId: item.ownerVatId,
          isExchangeRateDifference: item.isExchangeRateDifference,
        };

        calculateLineItem(
          newItem,
          this.taxRates,
          this.workingToFormalConversionRate
        );

        this.finDocModelInternal.lineItems.push(newItem);
      }
    }

    // calculate the discount (it should always be 0 since we've made it obsolete, but some old docs can have it so we need to do this just in case)
    const originalDiscountAmount = round(
      originalTotalPrice * (this.finDocModelInternal.discountPercent / 100),
      2
    );

    const addedDiscountAmount = data.reduce(
      (sum, e) => sum + e.discountAmount,
      0
    );
    const totalDiscount = originalDiscountAmount + addedDiscountAmount;

    const finalPrice = this.finDocModelInternal.lineItems.reduce(
      (sum, e) => sum + e.grossPrice,
      0
    );
    this.finDocModelInternal.discountPercent = round(
      (totalDiscount / finalPrice) * 100,
      6
    );

    // add any missing tax exemption reasons
    const missingTaxExemptions = data.reduce((sum, e) => {
      if (
        !sum.includes(e.taxExemptionReason) &&
        !this.finDocModelInternal.taxExemptionReason.includes(
          e.taxExemptionReason
        )
      )
        return [...sum, e.taxExemptionReason];
      return sum;
    }, [] as string[]);

    if (this.finDocModelInternal.taxExemptionReason.trim().length === 0)
      this.finDocModelInternal.taxExemptionReason =
        missingTaxExemptions.join("\n");
    else if (missingTaxExemptions.length > 0) {
      this.finDocModelInternal.taxExemptionReason +=
        "\n" + missingTaxExemptions.join("\n");
    }

    // add any missing notes
    const missingNotes = data.reduce((sum, e) => {
      if (
        !sum.includes(e.note) &&
        !this.finDocModelInternal.note.includes(e.note)
      )
        return [...sum, e.note];
      return sum;
    }, [] as string[]);

    if (this.finDocModelInternal.note.trim().length === 0)
      this.finDocModelInternal.note = missingNotes.join("\n");
    else if (missingNotes.length > 0) {
      this.finDocModelInternal.note += "\n" + missingNotes.join("\n");
    }

    this.multipleDocumentsInvoicingOpen = false;
  }

  getMultiDocumentLineItemName(
    item: MultipleDocumentsLineItem,
    document: MultipleDocumentsInvoicingViewModel
  ) {
    let name = item.itemName;
    const servicePeriodFromDate = new Date(item.servicePeriodFromDate ?? "");
    const servicePeriodToDate = new Date(item.servicePeriodToDate ?? "");

    if (
      !isNaN(servicePeriodFromDate.getTime()) &&
      !isNaN(servicePeriodToDate.getTime())
    ) {
      name +=
        " (" +
        servicePeriodFromDate.toLocaleDateString(this.internalLanguage) +
        " - " +
        servicePeriodToDate.toLocaleDateString(this.internalLanguage) +
        ")";
    }

    name += " - " + this.$t(document.documentTypeTextResourceKey).toString();

    if (
      document.documentInternalIdentifier &&
      document.documentInternalIdentifier.trim()
    ) {
      name += " " + document.documentInternalIdentifier;
    }
    return name;
  }

  refreshClientInfo() {
    if (this.finDocModelInternal.clientInfo.id) {
      Vue.axios
        .get<CustomerModel>(
          "/customers/" + this.finDocModelInternal.clientInfo.id
        )
        .then((x) => {
          const result = x.data;

          this.finDocModelInternal.clientInfo.isLegalEntity =
            result.isLegalEntity;
          this.finDocModelInternal.clientInfo.name = result.isLegalEntity
            ? result.legalEntityName ?? ""
            : [result.firstName, result.lastName]
                .filter((e) => !!e && e.length > 0)
                .join(" ");

          this.finDocModelInternal.clientInfo.countryId =
            result.countryOfResidenceId ?? null;
          this.finDocModelInternal.clientInfo.businessId =
            result.businessId ?? "";
          this.finDocModelInternal.clientInfo.identificationDocumentNumber =
            result.identificationDocumentNumber ?? "";
          this.finDocModelInternal.clientInfo.email = result.eMail ?? "";
          this.finDocModelInternal.clientInfo.phone =
            result.telephoneNumber ?? "";
          this.finDocModelInternal.clientInfo.address = [
            x.data.streetName,
            x.data.houseNumber,
          ]
            .filter((x) => !!x && x.length > 0)
            .join(" ");
          this.finDocModelInternal.clientInfo.postalCode =
            x.data.postalCode ?? "";
          this.finDocModelInternal.clientInfo.city = x.data.city ?? "";
        });
    } else {
      this.finDocModelInternal.clientInfo.name = "";
      this.finDocModelInternal.clientInfo.isLegalEntity = false;
      this.finDocModelInternal.clientInfo.address = "";
      this.finDocModelInternal.clientInfo.city = "";
      this.finDocModelInternal.clientInfo.businessId = "";
      this.finDocModelInternal.clientInfo.identificationDocumentNumber = "";
      this.finDocModelInternal.clientInfo.postalCode = "";
      this.finDocModelInternal.clientInfo.countryId = null;
      this.finDocModelInternal.clientInfo.email = "";
      this.finDocModelInternal.clientInfo.phone = "";
    }
  }

  // validation
  get rules() {
    return {
      requiredNoZero: (value: any) => !!value || this.$t("Validation.Required"),
      required: (value: any) =>
        !!value || value === 0 || this.$t("Validation.Required"),
      maxLength: (max: number) => (v: string) =>
        v.length <= max || this.$t("Validation.MaxLength", { count: max }),
    };
  }

  // settings and setup
  @Getter("language/language") language?: string;
  @Getter("appParams/disableCustomAddOnServiceLineItems")
  disableCustomAddOnServiceLineItems?: boolean;
  @Action("codebooks/refreshTaxRates") refreshTaxRates?: () => Promise<void>;
  @Getter("codebooks/taxRates") taxRatesGetter?: TaxRateView[];
  @Getter("codebooks/unitsOfMeasure") unitsOfMeasure?: UnitOfMeasureView[];
  @Getter("financial/settings") storedSettings?: FinancialSettingsType;

  get internalLanguage() {
    return this.language ?? "hr-HR";
  }

  get tenantPaysVat() {
    return this.storedSettings?.paysVat ?? false;
  }

  get taxRates() {
    return this.taxRatesGetter ?? [];
  }

  get workingToFormalConversionRate() {
    return this.finDocModelInternal.workingToFormalConversionRate ?? 1;
  }

  async created() {
    const promises = [];

    if ((this.taxRatesGetter?.length ?? 0) === 0 && this.refreshTaxRates) {
      promises.push(this.refreshTaxRates());
    }

    await Promise.all(promises);
  }
}
